import React from 'react'
import { useFormatMessage } from '@babylon/intl'
import {
  ModalContent,
  Text,
  LinkAnchor,
  EditorialLayout,
} from '@babylon/medkit'

import { useLocalisation } from '@/redux/productConfig/selectors'
import messages from './messages'
import DEFAULT from '@/config/premadeConfigs'

const OnlyNewUserModal = () => {
  const translate = useFormatMessage()
  const { region } = useLocalisation()
  const { FAQs } = DEFAULT
  const supportLink = FAQs[region as keyof typeof FAQs]

  return (
    <ModalContent title={translate(messages.title)}>
      <EditorialLayout>
        <Text variant="body">{translate(messages.description)}</Text>
        <LinkAnchor href={supportLink}>{translate(messages.link)}</LinkAnchor>
      </EditorialLayout>
    </ModalContent>
  )
}

export default OnlyNewUserModal
